import type { SizeInformationFragment } from '@shared/types/storefront/graphql'

export type SizeInformationData = {
  contentfulId: string | undefined
  pdfUrl: string | undefined
}

export const toSizeInformation = (
  sizeInformation: SizeInformationFragment | undefined | null
): SizeInformationData => {
  const reference = sizeInformation?.reference

  if (!reference || reference.__typename !== 'Metaobject') {
    return { contentfulId: undefined, pdfUrl: undefined }
  }

  return {
    contentfulId: reference.contentfulId?.value ?? undefined,
    pdfUrl: reference.pdfLink?.value ?? undefined,
  }
}
